import Vue from 'vue'
import Router from 'vue-router'
import localforage from 'localforage'

import store from '../store'

import Customer from '@/views/customer/Customer'
import Schedule from '@/views/schedule/Schedule'

import Login from '@/views/auth/Login'
import Register from '@/views/auth/Register'
import RegisterDev from '@/views/auth/Register.dev'
import ResetPassword from '@/views/auth/Reset-password'
import ForgetPassword from '@/views/auth/Forget-password'
import ProfileResetPassword from '@/views/profile/Reset-password'

import Profile from '@/views/profile'
import HistoryScheduleOnline from '@/views/history-schedule-online'
import PageNotFound from '@/views/page404'
import customersTheme from '../../config/customersTheme'

Vue.use(Router)
let env = process.env.NODE_ENV
console.log(env)
const router = new Router({
  mode: 'history', // Demo is living in GitHub.io, so required! hash
  history: true,
  linkActiveClass: 'is-active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      name: 'home',
      component: Schedule,
      meta: { auth: true }
    },
    {
      path: '/customer',
      name: 'customer',
      component: Customer,
      meta: { auth: false }
    },
    {
      path: '/patient/login',
      name: 'patientLogin',
      component: Login,
      meta: { auth: false }
    },
    {
      path: '/patient/reset-password',
      name: 'ResetPassword',
      component: ResetPassword,
      meta: { auth: false }
    },
    {
      path: '/patient/recovery-password',
      name: 'ProfileResetPassword',
      component: ProfileResetPassword,
      meta: { auth: true }
    },
    {
      path: '/patient/forget-password',
      name: 'ForgetPassword',
      component: ForgetPassword,
      meta: { auth: false }
    },
    {
      path: '/patient/history',
      name: 'HistoryScheduleOnline',
      component: HistoryScheduleOnline,
      meta: { auth: true }
    },
    {
      path: '/patient/register',
      name: 'patientRegister',
      component: env === 'development' ? RegisterDev : Register,
      meta: { auth: false }
    },
    {
      path: '/patient/profile',
      name: 'patientProfile',
      component: Profile,
      meta: { auth: true }
    }, {
      path: '/pagenotfound',
      name: 'PageNotFound',
      component: PageNotFound,
      meta: {
        auth: false
      }
    },
    {
      path: '*',
      redirect: '/patient/login'
    }
  ]
})

const storageKey = 'riscSchedulePatientCustomer'

const setCustomerTheme = (value) => {
  const customerTheme = customersTheme[value]
  return store
    .dispatch('app/setTheme', {
      color: customerTheme.theme,
      colorHTML: customerTheme.colorHTML
    })
    .then(() => {
      if (process.env.NODE_ENV !== 'production') {
        console.log('setTheme', customerTheme)
      }
    })
}

const setCustomer = (value) => {
  return store.dispatch('setCustomer', value)
    .then(() => localStorage.setItem(storageKey, value))
}

/* Protege a rota */
router.beforeEach((to, from, next) => {
  if ((to.path === '/patient/reset-password') && (to.query.token !== undefined)) {
    // console.log(to.path)
    // console.log(to.query.token)
    store.dispatch('setTokenRecoveryPassword', to.query.token).then(() => console.log('aaa'))
  }

  if (store.state.auth.token) {
    // console.log('aqui é o token', store.state.auth.token)
    window.axios.defaults.headers.common['x-access-token'] = store.state.auth.token
    window.axios.defaults.headers.common['Authorization'] = 'bearer ' + store.state.auth.token
  }

  const customer = to.query.customer || localStorage.getItem(storageKey)

  localforage.getItem('token').then((value) => {
    // console.log('rota', value)
  })
  localforage.getItem('user').then((value) => {
    // console.log('rota', value)
  })

  const promise = new Promise((resolve, reject) => {
    if (to.path !== '/pagenotfound') {
      if (customer in customersTheme) {
        setCustomer(customer)
          .then(() => setCustomerTheme(customer))
          .then(() => {
            if (process.env.NODE_ENV !== 'production') {
              console.log('cliente e tema resolvido')
            }
            resolve()
          })
      } else {
        console.log('pagenotfound')
        reject(new Error('Customer not found'))
      }
    } else {
      resolve()
    }
  })

  promise
    .then(() => {
      if (to.meta.auth === false) {
        return next()
      }

      if ((to.meta.auth !== undefined) || (to.meta.auth !== false) || (to.meta.auth !== undefined)) {
        if (!store.state.auth.isLogged && to.path !== '/patient/login') {
          return next('/patient/login')
        }
        return next()
      }
      return next()
    })
    .catch(() => next('/pagenotfound'))
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js